<template>
  <div class="region-selector">
    <div class="region-selector__overlay" @click="close"></div>
    <div class="region-selector__modal">
      <div class="region-selector__header">
        <h2 class="region-selector__title">Аймақты таңдаңыз</h2>
        <div class="region-selector__search">
          <input type="text" placeholder="Іздеу" v-model="search" />
          <button
            v-if="search"
            class="region-selector__clear"
            @click="clearSearch"
          >
            <svg-icon name="close" />
          </button>
        </div>

        <button class="region-selector__close" @click="close">
          <svg-icon name="close" />
        </button>
      </div>
      <div class="region-selector__content">
        <div v-if="selectedRegion" @click="back" class="region-selector__back">
          <button class="region-selector__back-button">
            <svg-icon name="left" />
          </button>
          <div class="region-selector__back-title">Артқа</div>
        </div>

        <ul v-if="!selectedRegion && !search" class="region-selector__list">
          <li
            v-for="region in regions"
            :key="region.id"
            class="region-selector__item"
            @click="selectRegion(region)"
          >
            {{ region.title }}
            <svg-icon name="arrow-right" class="fill-none" />
          </li>
        </ul>
        <ul v-else class="region-selector__list">
          <li
            v-for="city in [...cities, ...districts]"
            :key="city.id"
            class="region-selector__item"
            @click="select(city)"
          >
            <div class="flex flex-col">
              <div>{{ city.title }}</div>
              <div class="text-xs text-gray-500">
                {{ city.region }}
                <template v-if="city.district">, {{ city.district }}</template>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default defineComponent({
  name: "RegionSelector",
  components: {
    SvgIcon,
  },
  data() {
    return {
      isOpen: false,
      selectedRegion: null,
      search: "",
      searchTimeout: null,
    };
  },
  computed: {
    regions() {
      return this.$store.state.regions;
    },
    cities() {
      return this.$store.state.cities;
    },
    districts() {
      return this.$store.state.districts;
    },
  },
  async mounted() {
    await this.getRegions();
    if (this.selectedRegion) {
      await this.getCities();
      await this.getDistricts();
    }
  },
  watch: {
    selectedRegion(newVal) {
      if (!newVal) return;
      this.getCities();
      this.getDistricts();
    },
    search(newVal) {
      if (!newVal) {
        this.selectedRegion = null;
        return;
      }

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.searchRegions();
      }, 300);
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
      this.selectedRegion = null;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
    },
    searchRegions() {
      return this.$store.dispatch("searchRegions", this.search);
    },
    getRegions() {
      this.$store.dispatch("getRegions");
    },
    getCities() {
      this.$store.dispatch("getCities", this.selectedRegion);
    },
    getDistricts() {
      this.$store.dispatch("getDistricts", this.selectedRegion);
    },
    back() {
      this.selectedRegion = null;
    },
    select(city) {
      this.$store.dispatch("selectRegion", {
        lat: city.lat,
        lng: city.lng,
        title: city.title,
        id: city.id,
      });
      this.$emit("close");
    },
    open() {
      this.isOpen = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.$emit("close");
      document.body.style.overflow = "";
    },
    selectRegion(region) {
      this.selectedRegion = region.id;
      //   this.$emit("select", region);
      //   this.close();
    },
  },
});
</script>

<style scoped lang="scss">
.region-selector {
  @apply fixed inset-0 z-50 flex items-center justify-center;

  &__overlay {
    @apply absolute inset-0 bg-black/50;
  }

  &__modal {
    @apply relative bg-white rounded-lg w-full max-w-[500px] mx-4;
    @apply lg:mx-auto h-full max-h-[500px] flex flex-col overflow-y-auto;

    @media (max-width: 768px) {
      @apply m-4 max-h-[calc(100vh-32px)] rounded-lg;
    }
  }

  &__header {
    @apply flex flex-col p-3 px-5 border-b border-gray-200;
    @apply bg-zinc-50;

    .region-selector__search {
      @apply flex items-center justify-between relative;
      input {
        @apply mt-2 w-full p-3 py-1.5 rounded-lg border border-gray-200;
      }
      button {
        top: 15px;
        @apply absolute right-1.5 hover:bg-gray-100 rounded-lg transition-colors;
        svg {
          @apply w-6 h-6 text-gray-500;
        }
      }
    }
  }

  &__title {
    @apply text-xl font-semibold text-gray-900;
  }

  &__close {
    @apply absolute top-2 right-5 hover:bg-gray-100 rounded-lg transition-colors;
    svg {
      @apply w-7 h-7 text-gray-500;
    }
  }

  &__content {
    @apply flex flex-col h-full overflow-y-auto;
  }

  &__back {
    @apply flex items-center gap-x-2 p-3 px-5 text-gray-500;
    &:hover {
      @apply cursor-pointer text-gray-900;
    }
  }

  &__back-button {
    @apply w-6 h-6 flex items-center justify-center bg-gray-100 rounded-lg transition-colors;
    svg {
      @apply w-4 h-4;
    }
  }

  &__back-title {
    @apply text-sm;
  }

  &__list {
    @apply flex flex-col overflow-y-auto;
  }

  &__item {
    @apply border-0 border-b border-gray-200 py-3 flex items-center justify-between cursor-pointer;
    @apply px-5 hover:bg-gray-50 transition-colors;
  }
}
</style>
